import { StaticImage } from "gatsby-plugin-image"
import React, { useEffect, useRef, useState } from "react"
import Layout from "../components/layout"
import ContentDiv from "../components/contentDiv"
import Text, { TextType } from "../components/text"
import styled from "styled-components"
import { tablet } from "../util/mediaQueries"
import PageImage from "../components/pageImage"
import SEO from "../components/seo"
import { Media } from "gatsby-plugin-fresnel"
import FirstSection from "../components/firstSection"

const HeaderDiv = styled.div`
  width: 100%;
  text-align: center;
  margin-bottom: 20px;
  padding-top: 70px;
  padding-bottom: 70px;
`

// Server-side data fetching function
export async function getSteuernewsData() {
  try {
    // Fetch the actual HTML content directly from aktuelles.html
    // This bypasses the JavaScript loader (erv.js) and gets the content directly
    const response = await fetch('https://107802.mainfo.net/aktuelles.html');

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const htmlContent = await response.text();
    
    // Return the actual HTML content with styles
    return {
      success: true,
      content: htmlContent
    };
  } catch (error) {
    console.error('Server-side fetch error:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error',
      content: `
        <div style="text-align: center; padding: 20px; color: #666;">
          <h3>Steuernews</h3>
          <p>Die aktuellen Steuernews konnten nicht geladen werden.</p>
          <p>Bitte versuchen Sie es später erneut.</p>
        </div>
      `
    };
  }
}

const Steuernews = () => {
    const [content, setContent] = useState<string>('')
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [error, setError] = useState<string>('')

    useEffect(() => {
        const fetchContent = async () => {
            try {
                setIsLoading(true)
                
                // Use the server-side function directly
                const result = await getSteuernewsData()
                
                if (result.success) {
                    setContent(result.content)
                    setError('')
                } else {
                    setError(result.error || 'Unknown error occurred')
                }
            } catch (err) {
                console.error('Error fetching steuernews:', err)
                setError(`Failed to load content: ${err instanceof Error ? err.message : 'Unknown error'}`)
            } finally {
                setIsLoading(false)
            }
        }

        fetchContent()
    }, [])

    return (
        <Layout>
            <PageImage>

                <Media greaterThanOrEqual="md">
                    <StaticImage


                        src="../images/Titelbild_Steuernews_PC.jpeg"
                        quality={95}
                        formats={["auto", "webp", "avif"]}
                        alt="Image"
                        objectFit="contain"
                        layout="fullWidth"
                    />
                </Media>
                <Media at="sm">
                    <StaticImage


                        src="../images/Titelbild_Steuernews_Smartp.jpeg"
                        quality={95}
                        formats={["auto", "webp", "avif"]}
                        alt="Image"
                        objectFit="contain"
                        layout="fullWidth"
                    />
                </Media>
            </PageImage>

            <FirstSection headerText="Steuernews" >
                Immer aktuell mit unseren Steuernews:
                Erfahren Sie laufend aktuelle Informationen sowie steuerliche und gesetzliche Neuerungen!
            </FirstSection>
            <ContentDiv>
                {/* Display content */}
                {error ? (
                    <div style={{ textAlign: 'center', padding: '40px', color: 'red' }}>
                        <p>Error: {error}</p>
                        <button 
                            onClick={() => window.location.reload()} 
                            style={{ 
                                padding: '10px 20px', 
                                marginTop: '10px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer'
                            }}
                        >
                            Retry
                        </button>
                    </div>
                ) : content ? (
                    <div dangerouslySetInnerHTML={{ __html: content }} />
                ) : (
                    <div style={{ textAlign: 'center', padding: '40px' }}>
                        <p>{isLoading ? 'Loading news content...' : 'No content available'}</p>
                        {isLoading && (
                            <div style={{ marginTop: '20px' }}>
                                <div style={{ 
                                    width: '40px', 
                                    height: '40px', 
                                    border: '4px solid #f3f3f3', 
                                    borderTop: '4px solid #007bff', 
                                    borderRadius: '50%', 
                                    animation: 'spin 1s linear infinite',
                                    margin: '0 auto'
                                }} />
                                <style>{`
                                    @keyframes spin {
                                        0% { transform: rotate(0deg); }
                                        100% { transform: rotate(360deg); }
                                    }
                                `}</style>
                            </div>
                        )}
                    </div>
                )}
            </ContentDiv>
        </Layout>)

}

// Gatsby Head API - modern way to manage document head
export const Head = () => {
  const seoData = SEO({ lang: "de", title: "Steuernews" })
  
  return (
    <>
      <html lang={seoData.lang} />
      <title>{seoData.titleTemplate ? seoData.titleTemplate.replace('%s', seoData.title) : seoData.title}</title>
      {seoData.meta.map((meta, index) => (
        <meta key={index} name={meta.name} property={meta.property} content={meta.content} />
      ))}
    </>
  )
}

export default Steuernews
